<style>
    .box-recipient-container {
        min-height: 125px;
    }
    .recipient-container,
    .recipient-info-container,
    .recipient-info {
        display: flex;
    }
    .recipient-container {
        justify-content: space-between;
        padding: 0 8px;
    }
    .recipient-info-container {
        align-items: center;
    }
    .recipient-info {
        flex-direction: column;
        padding-left: 4px;
    }
    .supporting {
        border-top: 1px solid var(--neutral3);
        padding-top: 8px;
    }
</style>

<template>
    <cp-box light-hover :outlined="outlined" :highlighted-thick="recipient.created_campaign_at !== null" spread class="box-recipient-container text-center">
        <cp-grid spread column stretch-content justify="spaceBetween" style="max-width: '100%'">
            <cp-grid-item span="12" align="center">
                <div class="recipient-container">
                    <a class="no-underline recipient-info-container" :href="permalink">
                        <cp-image :src="recipient.recipient.large_img" alt="recipient.recipient.name" width="40px" :circular="recipient.type === 'candidate'"></cp-image>
    
                        <div class="recipient-info">
                            <h3 class="subheadline2 black-color text-left" v-margin-bottom="0.2" v-text="capitalizeWords(recipient.recipient.name)"></h3>
                            <p class="caption2 neutral4-color text-left" v-margin-top="0" v-text="recipient.recipient.subtitle"></p>
    
                            <div v-if="recipient.endorsement_description">
                                <hr>
    
                                <p class="caption2 neutral4-color text-left" v-margin-bottom="1" >
                                    <cp-truncate length="118">{{recipient.endorsement_description}}</cp-truncate>
                                </p>
                            </div>
                        </div>
                    </a>
                    <div v-if="canEdit">
                        <cp-tooltip-toggle style="cursor:pointer" :for="actionTooltipId">
                            <i class="fal fa-ellipsis-v neutral4-color fa-2x"></i>
                        </cp-tooltip-toggle>
                        <cp-tooltip class="text-left" light :id="actionTooltipId">
                            <a style="font-size:14px;" href="#" @click.prevent="updateRecipient">{{isVisible ? 'Hide this from my public profile' : 'Show this on my public profile'}}</a>
                            <hr v-margin=".75">
                            <a href="#" class="color-twitter" v-share-on-twitter="twitterShare" style="font-size:14px;">Share on Twitter</a>
                            <br />
                            <a href="#" class="color-facebook" v-share-on-facebook="facebookShare" style="font-size:14px;">Share on Facebook</a>
                        </cp-tooltip>
                    </div>
                </div>
            </cp-grid-item>
            <cp-grid-item span="content" v-margin-top="0">
                <a class="no-underline" :href="permalink">
                    <cp-box-content v-margin="0" v-margin-bottom="1">
                        <cp-grid v-if="showActions" justify="center">
                            <cp-grid-item v-if="recipient.created_campaign_at" span="content">
                                <cp-tooltip-toggle :for="recipientKey+'-tooltip-created-campaign'" hoverable>
                                    <img src="https://res.cloudinary.com/crowdpac/image/upload/v1521155886/assets/created_2x.png" height="40" width="40" alt="Campaign Created" />
                                </cp-tooltip-toggle>
                            </cp-grid-item>
                            <cp-grid-item v-if="recipient.total_contributions > 1" span="content">
                                <cp-tooltip-toggle :for="recipientKey+'-tooltip-multi-donor'" hoverable>
                                    <img src="https://res.cloudinary.com/crowdpac/image/upload/v1520553703/assets/multi_donated_2x.png" height="40" width="40" alt="Multiple Contributions" />
                                </cp-tooltip-toggle>
                            </cp-grid-item>

                            <cp-grid-item v-if="recipient.donated_at || recipient.pledged_at" span="content">
                                <cp-tooltip-toggle :for="recipientKey+'-tooltip-contributed'" hoverable>
                                    <img src="https://res.cloudinary.com/crowdpac/image/upload/v1520553703/assets/donated_2x.png" height="40" width="40" alt="Contributed" />
                                </cp-tooltip-toggle>
                            </cp-grid-item>

                            <cp-grid-item v-if="recipient.endorsed_at" span="content">
                                <cp-tooltip-toggle :for="recipientKey+'-tooltip-endorsed'" hoverable>
                                    <img src="https://res.cloudinary.com/crowdpac/image/upload/v1520553703/assets/endorsed_2x.png" height="40" width="40" alt="Endorsed" />
                                </cp-tooltip-toggle>
                            </cp-grid-item>
                        </cp-grid>

                        <cp-tooltip :id="recipientKey+'-tooltip-created-campaign'">
                            <p>
                                Created Campaign
                            </p>
                        </cp-tooltip>
                        <cp-tooltip :id="recipientKey+'-tooltip-multi-donor'">
                            <p>
                                Multiple Contributions!
                            </p>
                        </cp-tooltip>
                        <cp-tooltip :id="recipientKey+'-tooltip-contributed'">
                            <p>
                                Contributed
                            </p>
                        </cp-tooltip>
                        <cp-tooltip :id="recipientKey+'-tooltip-endorsed'">
                            <p>
                                Endorsed
                            </p>
                        </cp-tooltip>

                        <p class="caption2 neutral4-color supporting" v-margin-bottom="0" v-if="recipient.date_formatted">
                            <span v-if="isOnlyFollowing">Following since</span>
                            <span v-else-if="recipient.created_campaign_at">Campaign Created</span>
                            <span v-else>Supporter since</span>
                            {{recipient.date_formatted}}
                        </p>

                        <!-- showing supporters? -->

                        <div v-if="false && recipient.recipient.user_supporters_count">
                            <p class="content-3" v-margin-top="0" v-margin-bottom="1">
                                {{recipient.recipient.user_supporters_count + ' supporter' +
                                (recipient.recipient.user_supporters_count === 1 ? '' : 's') }}
                            </p>
                            <div v-if="recipient.show_user_supporters">
                                <cp-box-content>
                                    <cp-grid tight>
                                        <cp-grid-item span="2" v-for="user_supporter in recipient.user_supporters" :key="user_supporter.id">
                                            <a :title="user_supporter.name" :href="user_supporter.permalink"><cp-image :src="user_supporter.small_img" alt="user_supporter.name" width="100%" circular></cp-image   ></a>
                                        </cp-grid-item>
                                    </cp-grid>
                                    <div v-if="recipient.user_supporters_next_page">
                                        <a @click.prevent="showMoreUserSupporters(recipient.type, recipient.type_id, recipient.user_supporters_next_page)" href="#">more ...</a>
                                    </div>
                                </cp-box-content>
                            </div>
                        </div>
                    </cp-box-content>
                </a>
            </cp-grid-item>
        </cp-grid>
    </cp-box>
</template>

<script>
    import axios from 'axios';

    export default {
        directives: Object.assign(
            {},
            require('./directives/font'),
            require('./directives/margins'),
            require('./directives/share'),
        ),

        components: {
            CpBox: require('./box').default,
            CpBoxContent: require('./box-content').default,
            CpButton: require('./button').default,
            CpButtonLink: require('./button-link').default,
            CpGrid: require('./grid').default,
            CpGridItem: require('./grid-item').default,
            CpIcon: require('./icon').default,
            CpImage: require('./image').default,
            CpTooltip: require('./tooltip').default,
            CpTooltipToggle: require('./tooltip-toggle').default,
            CpTruncate: require('./truncate').default,
            capitalizeWords: require('./mixins/utils.js').default,
        },

        props: {
            canEdit: {
                type: Boolean,
                default: false
            },
            outlined: {
                type: Boolean,
                default: true
            },
            defaultVisibility: String,
            recipient: Object,
            appendToHref: {
                type: String,
                default: ''
            }
        },

        computed: {
            actionTooltipId() {
                return 'recipient-edit-tooltip-' + this.recipientKey;
            },
            recipientKey() {
                return this.recipient.type + this.recipient.recipient.id;
            },
            isVisible() {
                return this.recipient.visibility_state === 'visible' || (!this.recipient.visibility_state && this.defaultVisibility === 'visible');
            },
            permalink() {
                return this.recipient.recipient.permalink + this.appendToHref;
            },
            twitterShare() {
                return {
                    text: 'I support ' + this.recipient.recipient.name + ' on my personal @CrowdBlue profile, check them out here:',
                    url:  this.permalink,
                }
            },
            facebookShare() {
                return {
                    url:  this.permalink,
                }
            },
            isOnlyFollowing() {
                return this.recipient.followed_at &&
                        !this.recipient.created_campaign_at &&
                        !this.recipient.pledged_at &&
                        !this.recipient.donated_at &&
                        !this.recipient.endorsed_at;
            },
            showActions() {
                return this.recipient.created_campaign_at || this.recipient.total_contributions > 1 || this.recipient.donated_at || this.recipient.pledged_at || this.recipient.endorsed_at;
            },
        },

        methods: {
            updateRecipient() {
                this.$root.hideTooltip(this.actionTooltipId)
                this.recipient.visibility_state = this.isVisible ? 'hidden' : 'visible';
                this.$emit('update', this.recipient);
            },

            toggleUserSupporters(type, type_id) {
                let needsData = false;

                // see if toggle is on yet
                if (!('show_user_supporters' in this.recipient)) {
                    this.$set(this.recipient, 'show_user_supporters', false);
                    needsData = true;
                }

                // see if we have data yet
                if (needsData) {
                    axios.get('/apiv2/user-support/users', {params: {type, type_id}})
                        .then((response) => {
                            this.$set(this.recipient, 'user_supporters', response.data.data.users);
                            this.$set(this.recipient, 'user_supporters_next_page', response.data.data.nextPage);
                        });
                }

                // Now toggle
                this.recipient.show_user_supporters = !this.recipient.show_user_supporters;
            },

            showMoreUserSupporters(type, type_id, page) {
                axios.get('/apiv2/user-support/users', {params: {type, type_id, page}})
                    .then((response) => {
                        this.recipient.user_supporters = this.recipient.user_supporters.concat(response.data.data.users);
                        this.recipient.user_supporters_next_page = response.data.data.nextPage;
                    });
            },
        }
    }
</script>
